import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Message, Header } from 'semantic-ui-react';
const RegistrationComplete = props => {
	return (
		<Container>
			<Header as='h1' textAlign='center' content='Account Registration' />
			<Message info>
				<div>Thank you for registering.</div>
				<div>We have sent an email with a confirmation link to your email address.</div>
				<div>Questions? Please contact Customer Service at 800.477.1660.</div>
			</Message>
			{props.resendSuccess ? <Message info content='An email has been sent.' /> : null}
			<div className='row-center' style={{ display: 'flex' }}>
				<Link className='ui basic fluid button' to='/login'>
					Login
				</Link>
				{props.children}
			</div>
		</Container>
	);
};

RegistrationComplete.propTypes = {
	resendSuccess: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default RegistrationComplete;
